/* Size the still seasonal backdrop to the actual masthead and hero. */
(() => {
  'use strict';

  const root = document.documentElement;
  let header;
  let hero;
  let observer;
  let frame = 0;
  let lastHeight = 0;

  function measure() {
    frame = 0;
    if (!header?.isConnected || !hero?.isConnected) return;
    const height = Math.ceil(header.getBoundingClientRect().height + hero.getBoundingClientRect().height);
    if (height > 0 && height !== lastHeight) {
      root.style.setProperty('--vxw-scene-height', `${height}px`);
      lastHeight = height;
    }
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(measure);
  }

  function disconnect() {
    observer?.disconnect();
    observer = undefined;
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    header = undefined;
    hero = undefined;
  }

  function connect() {
    disconnect();
    if (!document.body.classList.contains('varelix-halloween')) return;
    header = document.getElementById('header-group');
    hero = document.querySelector('.vxw-hero');
    if (!header || !hero) return;
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      for (const element of [header, hero]) {
        try {
          observer.observe(element, { box: 'border-box' });
        } catch {
          observer.observe(element);
        }
      }
    }
    schedule();
  }

  function unload(event) {
    const section = event.target;
    if (!section?.contains || (!section.contains(header) && !header?.contains(section) && !section.contains(hero))) return;
    disconnect();
    lastHeight = 0;
    root.style.removeProperty('--vxw-scene-height');
  }

  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', unload);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
})();
